import React from 'react';
import { createRoot } from 'react-dom/client';
import * as Sentry from '@sentry/react';

Sentry.init({
  dsn: 'https://d8dd3ce9d64037831b89bc2913e58851@o4510062803025920.ingest.de.sentry.io/4510062804009040',
  sendDefaultPii: true,
  enableLogs: true,
});

export const seedHotelUuid = () => {
  try {
    const url = new URL(window.location.href);
    const fromPath = url.pathname.match(/\/h\/([0-9a-fA-F-]{36})(?=\/|$)/)?.[1];
    const incoming = fromPath;
    const current = localStorage.getItem('hotel_uuid');

    if (incoming) {
      if (incoming !== current) {
        localStorage.setItem('hotel_uuid', incoming);
        console.log('[kiosk] hotel_uuid updated in localStorage:', incoming);
      }
      let newPath = url.pathname.replace(/\/h\/([0-9a-fA-F-]{36})(?=\/|$)/, '');
      if (newPath === '') newPath = '/';
      const newUrl = url.origin + newPath + url.search;
      window.history.replaceState(null, '', newUrl);
    } else if (current) {
      console.log(
        '[kiosk] using existing hotel_uuid from localStorage:',
        current
      );
    } else {
      console.log('[kiosk] no hotel_uuid found in URL or localStorage');
    }
  } catch (e) {
    console.error('[kiosk] error while seeding hotel_uuid:', e);
  } finally {
    const root = createRoot(document.getElementById('root'));
    import('./App').then(({ default: App }) => {
      root.render(
        <React.StrictMode>
          <Sentry.ErrorBoundary fallback={<p>Something went wrong</p>}>
            <App />
          </Sentry.ErrorBoundary>
        </React.StrictMode>
      );
    });
  }
};
